// extracted by mini-css-extract-plugin
export default {"commentBox":"Journal_commentBox__JuD3c","noBold":"Journal_noBold__Kx6HG","updateBox":"Journal_updateBox__GiFo3"};